module.exports = (conversationFlow, incomingMessage, lastBotMessage) => {
    //UTIL -> checks if string matches any array of RegExp element
    const checkRegexMatch = (string, regexArray) => {
        return regexArray.some(regex => regex.test(string))
    }

    //conversationFlow: array of flow elements, incomingMessage: string, lastBotMessage: anything I return from generateAnswer(this funcition)

    //Find matching message. If there's no lastBotMessage will use 'welcome'
    const lastMessageCode = lastBotMessage ? lastBotMessage.code : 'welcome'

    //Get the one where the regex matches
    const generatedMessage = conversationFlow.find(element => element.matches.some(match => lastMessageCode === match.code && checkRegexMatch(incomingMessage, match.regex)))

    return generatedMessage ? generatedMessage : null
}